import { ElementType, lazy, Suspense } from 'react';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const NotFound = Loadable(lazy(() => import('../screens/Page404')));
export const Hypotension = Loadable(lazy(() => import('../screens/hypotension/Hypotension')));
export const Cutoff = Loadable(lazy(() => import('../screens/cutoff/Cutoff')));
export const AuthInfo = Loadable(lazy(() => import('../screens/auth-info/AuthInfo')));
export const MyInfo = Loadable(lazy(() => import('../screens/management/my-info/MyInfo')));
export const Main = Loadable(lazy(() => import('../screens/main/Main')));


